import { PATIENT_HEALTH_SUMMARY_WITH_POOLING } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface PatientHealthSummaryWithPoolingResponse {
    most_recent_summary?: PatientHealthMostRecentSummary;
    status: PatientHealthSummaryWithPoolingResponseStatus;
    information_hash?: string;
}

export type PatientHealthMostRecentSummary = {
    six_month_overview: string;
    suggested_lab_tests: {
        name: string;
        reason: string;
    }[];
    tags: string[];
    spans: [number, number][];
    schema_hash?: string;
    model_id?: string;
};

export type PatientHealthSummaryWithPoolingResponseStatus =
    | 'PENDING'
    | 'IN_PROGRESS'
    | 'NO_DATA'
    | 'SUCCESS'
    | 'ERROR';

export default (
    patientId: string,
    information_hash?: string,
): Promise<PatientHealthSummaryWithPoolingResponse> => {
    return fetchWithRefresh(PATIENT_HEALTH_SUMMARY_WITH_POOLING(patientId, information_hash), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('Failed to fetch Summary Details');
        }
    });
};
